import _ from "lodash";

export class Strenger {

    static regNavn = "Strenger";

    static forInjisering() {
        return [Strenger]
    }

    constructor() {
    }

    //offentlige metoder

    førsteOrd(tekst: string): string {
        if (_.isEmpty(_.trim(tekst))) return "";
        return tekst.trim().split(" ")[0];
    }

    initialer(navn: string): string {
        if (_.isEmpty(_.trim(navn))) return "";
        var ord = _(navn.trim().split(" ")).compact().map(del => _.toUpper(del[0]));
        return ord.first() + (ord.size() > 1 ? ord.last() : "");
    }

    listeTilStreng(liste: string[], skilletegn: string, sisteSkilletegn: string): string {
        if (_.isEmpty(liste)) return "";

        return _(liste).compact().reduce(
            (accumulator, value, index, collection) => {
                var skille = "";
                if (index == 0) skille = "";
                else if (index == collection.length - 1) skille = " " + sisteSkilletegn + " ";
                else skille = skilletegn + " ";
                return accumulator + skille + value;
            },
            "");
    }

}


export function sisteElementEtter(tekst: string, separator: string): string {
    if (_.isEmpty(tekst)) return "";
    return tekst.trim().split(separator).reverse()[0];
}

export function somAsciiSmåBokstaver(tekst: string): string {
    if (_.isEmpty(tekst)) return "";
    return tekst.trim()
        .toLowerCase()
        .replace("ø", "oe")
        .replace("æ", "ae")
        .replace("å", "aa");
}

export function erLikIgnorerCasing(a: string, b: string): boolean {
    if (a === b) return true;
    return _.toLower(a) === _.toLower(b)
}
